export interface TokenRow {
  token: string
  cssVar: string
  className: string
  step: string
  desc: string
}

export interface TokenGroup {
  group: string
  tokens: TokenRow[]
}

interface Props {
  groups: TokenGroup[]
}

export default function TokenGroupTable({ groups }: Props) {
  return (
    <div className="space-y-8">
      {groups.map(({ group, tokens }) => (
        <div key={group}>
          <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.16em] text-fg-secondary">{group}</p>
          <div>
            {tokens.map(({ token, cssVar, className, step, desc }) => (
              <div
                key={token}
                className="grid grid-cols-[14rem_3rem_8rem_1fr] items-center gap-4 py-2 border-b border-line last:border-b-0"
              >
                <p className="font-mono text-xs text-fg">{token}</p>
                <div
                  className={`h-7 w-full rounded border border-line ${className}`}
                  style={
                    token.startsWith('text-') || token.startsWith('border-')
                      ? { backgroundColor: `var(${cssVar})` }
                      : undefined
                  }
                />
                <p className="font-mono text-[10px] text-fg-secondary">{step}</p>
                <p className="text-sm text-fg-secondary">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
